import { Injectable, EventEmitter, Renderer2, RendererFactory2 } from '@angular/core';
import { StorageService } from './storage.service';
import * as moment from 'moment';


@Injectable({
  providedIn: 'root'
})
export class CommonService {
  private renderer: Renderer2;
  /**
   * use to re-sizing the girdster size
   */
  toggleSideBar: EventEmitter<any> = new EventEmitter();

  /**
   * use to update the application
   */
  updateApplication: EventEmitter<any> = new EventEmitter();

  /**
   * use to update the theme of application
   */
  updateTheme: EventEmitter<any> = new EventEmitter();

  /**
   * use to save value of new related record
   */
  newRelatedRecordValue:any;

  /**
   * value for email passed
   */
  enteredEmailInAuth!: string;

  /**
   * Used to toggle print form
   */
  printForm: EventEmitter<any> = new EventEmitter();

  openedToolTip!:any;
  public actionColumnWidth: number = 170;
  public actionColumnWidthDefault: number = 170;
  public is_small_screen: boolean =false;
  public updatedToggleCollapse: boolean =false;

  titleToIconMap: { [title: string]: string } = {
    'fa fa-upload': 'e-icons e-align-top',
    'fa fa-plus': 'e-icons e-form-field',
    'fa fa-sitemap': 'e-icons e-people',
    'fa fa-line-chart': 'e-icons e-chart-2d-pie-2',
    'fa fa-file-text': 'e-icons e-page-columns',
    'fa fa-repeat': 'e-icons e-repeat',
    'fa fa-bell': 'e-icons e-circle-add',
    'fa fa-eye': 'e-icons e-eye',
    'fa fa-gear': 'e-icons e-settings',
  };
  titleToIconMapForOpenGov: { [title: string]: string } = {
    'fa fa-upload': 'material-icons material-icons-upload',
    'fa fa-plus': 'material-icons material-icons-view_list',
    'fa fa-sitemap': 'fluent-People',
    'fa fa-line-chart': 'material-icons material-icons-pie_chart',
    'fa fa-file-text': 'material-icons material-icons-text_snippet',
    'fa fa-repeat': 'fluent-ArrowRepeatAll',
    'fa fa-bell': 'fluent-AddCircle',
    'fa fa-eye': 'fluent-EyeShow',
    'fa fa-gear': 'icon-setting',
  };

  get defaultIconColor() {
    return this.isIgnatiusThemeApplied ? '#fff' : '#616365';
  }

  private onWindowLoad = () =>
    this.setGoogleTranslateLanguage(this.storage.getAppLanguage() || 'en');

  constructor(
    private storage:StorageService,
    private rendererFactory: RendererFactory2
  ) { 
    this.renderer = this.rendererFactory.createRenderer(null, null);
    window.addEventListener('load', this.onWindowLoad);
  }

  setIgnatiusTheme() {
    document.body.classList.remove('opengov-theme');
    document.body.classList.add('ignatius-theme');
    this.updateTheme.emit('ignatius-theme');
    this.changeFavicon('./assets/images/favicon.ico');
    this.updateWidgetColors('#0083ff');
  }

  setOpenGovTheme() {
    document.body.classList.remove('ignatius-theme');
    document.body.classList.add('opengov-theme');
    this.updateTheme.emit('opengov-theme');
    this.changeFavicon('favicon.ico');
    this.updateWidgetColors('#4b3fff');
  }

  get isIgnatiusThemeApplied() {
    return document.body.classList.contains('ignatius-theme') || false;
  }

  setGoogleTranslateLanguage(languageCode: string): void {
    this.storage.saveLanguage(languageCode)
    const currentLang = document.documentElement.lang;
    if(currentLang === 'en' || currentLang === 'ab' || currentLang === 'auto' || languageCode === 'en'){
      document.body.classList.add('notranslate');
    } else {
      document.body.classList.remove('notranslate');
    }
    document.cookie = 'googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    document.cookie = `googtrans=/${languageCode}; path=/; domain=${window.location.hostname}`;
    const googleTranslateSelect = document.querySelector('.goog-te-combo') as HTMLSelectElement;
    if (googleTranslateSelect) {
      googleTranslateSelect.value = languageCode;
      googleTranslateSelect.dispatchEvent(new Event('change'));
    }
  }
  
  getFilteredData(searchCols:any, globalSearch:any,searchArr:any,refactoringDataArr:any,dTColumns:any,filterCondition?:any,datatableColumn?:any){
    if (searchCols?.length) {
      refactoringDataArr?.forEach((el: any) => {
        let isMatch = true;
        searchCols?.forEach((e:any) => {
          const columnValue = el[e.data]?.toString()?.toLowerCase()?.replace(/\s+/g, ' ');
          const searchValue = e.search.value?.toLowerCase()?.trim();;
    
          if (searchValue === '-' && !columnValue) {
            return; 
          }

          if (searchValue === 'false' && e.data === "isnullable" && !columnValue) {
            return; 
          }
    
          if (!columnValue || !columnValue.includes(searchValue)) {
            isMatch = false;
          }
        });
    
        if (isMatch && searchArr?.indexOf(el) < 0) {
          searchArr.push(el);
        }
      });
    }
    
    let globalSearchArr: any[] = [];
    if (globalSearch) {
      refactoringDataArr?.forEach((el: any) => {
        let isGlobalMatch = false;
    
        dTColumns?.forEach((col: any) => {
          const columnValue = el[col]?.toString()?.toLowerCase().replace(/\s+/g, ' ');
    
          if (globalSearch === '-' && !columnValue) {
            isGlobalMatch = true;
          }

          if (globalSearch === 'false' && col === "isnullable" && !columnValue) {
            isGlobalMatch = true;
          }
    
          if (columnValue && columnValue.includes(globalSearch?.replace(/\s+/g, ' '))) {
            isGlobalMatch = true;
          }
        });
    
        if (isGlobalMatch) {
          globalSearchArr.push(el);
          // if(searchArr.indexOf(el) < 0) searchArr.push(el)
        }
      });
    }

    let filteredData:any = [];
    if(filterCondition){
      filteredData = this.filterData(globalSearch ? globalSearchArr : refactoringDataArr, filterCondition, datatableColumn);
    }
    
    if(filterCondition?.length){ 
      return filteredData;
    } else if (globalSearch) {
      if(searchCols?.length){
        return globalSearchArr?.filter((row:any) => searchArr.includes(row));
      }
      return globalSearchArr;
    } else if(searchCols?.length){
      return searchArr;
    }
    return [];
  }
  
  // Method to toggle action menu visibility for small screens
  toggleActionMenu(row: any,rowIndex: any, tooltipInstance?:any): void {  
    this.openedToolTip = tooltipInstance;
    this.openedToolTip?.toggle();
  }

  initializeActionColumn(width: number){
    this.actionColumnWidth = width;
    this.actionColumnWidthDefault = width;
    this.setIsSmallScreen(this.is_small_screen);
  }

  setIsSmallScreen(isSmall:boolean = false){
    this.is_small_screen = isSmall
    this.actionColumnWidth = isSmall ? 70 : this.actionColumnWidthDefault;
  }

  compareValues = (
    columnName:string,
    inputValue: string | number | boolean,
    operator: string,
    conditionValue: string | number | boolean
  ) => {
    let date1, date2;
    switch (operator) {
      case 'empty':
        return inputValue === '' || inputValue === null || inputValue === undefined || (Array.isArray(inputValue) && !inputValue.length);
      case 'has value':
        return inputValue || (inputValue !== '' && inputValue !== null && inputValue !== undefined) || (Array.isArray(inputValue) && inputValue.length);
      case 'is equal to role':
      case 'is equal to user':
      case 'is equal':
        if(columnName === 'is_public?' || columnName === 'default'){
          return (inputValue === 'true' ? 1:0) === conditionValue;
        } else if(columnName === 'isnullable'){
          return inputValue == conditionValue;
        }
        return (
          inputValue?.toString()?.toLowerCase()?.trim()?.replace(/\s+/g, ' ') === conditionValue?.toString()?.toLowerCase()?.trim()
        );
      case 'is not equal':
        return inputValue?.toString()?.toLowerCase()?.trim()?.replace(/\s+/g, ' ') != conditionValue?.toString()?.toLowerCase()?.trim();
      case 'contain':
        return inputValue?.toString()?.toLowerCase()?.trim()?.replace(/\s+/g, ' ')?.includes(conditionValue.toString()?.toLowerCase()?.trim());
      case 'not contain':
        return !inputValue?.toString()?.toLowerCase()?.trim()?.replace(/\s+/g, ' ')?.includes(conditionValue.toString()?.toLowerCase()?.trim());
      case 'start with':
        return inputValue?.toString()?.toLowerCase()?.trim()?.replace(/\s+/g, ' ')?.startsWith(conditionValue.toString()?.toLowerCase()?.trim());
      case 'end with':
        return inputValue?.toString()?.toLowerCase()?.trim()?.replace(/\s+/g, ' ')?.endsWith(conditionValue.toString()?.toLowerCase()?.trim());
      case 'greater than or equal to':
        return Number(inputValue) >= Number(conditionValue);
      case 'less than or equal to':
        return Number(inputValue) <= Number(conditionValue);
      case 'greater than':
        return Number(inputValue) > Number(conditionValue);
      case 'less than':
        return Number(inputValue) < Number(conditionValue);
      case 'between_date':
        date1 = (conditionValue as string).split(',')[0];
        date2 = (conditionValue as string).split(',')[1];
        return moment(inputValue as string,"MM/DD/YYYY hh:mm A").isBetween(
          moment(date1,"YYYY-MM-DD").startOf('day'),
          moment(date2,"YYYY-MM-DD").endOf('day')
        );
      case 'not_between_date':
        date1 = (conditionValue as string).split(',')[0];
        date2 = (conditionValue as string).split(',')[1];
        return !moment(inputValue as string, "MM/DD/YYYY hh:mm A").isBetween(
          moment(date1,"YYYY-MM-DD").startOf('day'),
          moment(date2,"YYYY-MM-DD").endOf('day')
        );
      case 'days_before_today':
        return (
          moment().diff(moment(inputValue as string,"MM/DD/YYYY hh:mm A"), 'days') == conditionValue
        );
      case 'before_date':
        return (
          moment(inputValue as string,"MM/DD/YYYY hh:mm A").isBefore(
            moment(conditionValue as string),
          )
        );
      case 'on_or_before_date':
        return moment(inputValue as string,"MM/DD/YYYY hh:mm A").isSameOrBefore(
          moment(conditionValue as string)
        );
      case 'after_date':
        return (
          moment(inputValue as string,"MM/DD/YYYY hh:mm A").isAfter(
            moment(conditionValue as string)
          )
        );
      case 'on_or_after_date':
        return moment(inputValue as string,"MM/DD/YYYY hh:mm A").isSameOrAfter(
          moment(conditionValue as string)
        );
      default:
        return false;
    }
  };

  filterData(data: any[], filters: any[], columns: any[]): any[] {
    return data.filter(row => {
      return filters.every((filter:any) => {
        if (filter.Type === 'any') {
          return filter.Conditions.some((condition:any) => {
            const column = columns.find(col => col.FieldName === condition.ConditionFieldName);
            return column && this.compareValues(condition.ConditionFieldName,row[condition.ConditionFieldName] ? row[condition.ConditionFieldName]:'' , condition.OperationType, condition.Value);
          });
        }
        return true;
      });
    });
  }
  
  scrollToTop(){
    if ('scrollBehavior' in document.documentElement.style) { 
      window.scrollTo({ top: 0, behavior: 'smooth' }); 
    } else { 
      window.scrollTo(0, 0); 
    }
  }

  setOGSupportActive(isOGWidgetActive: boolean){
    const ogHelpButton = document.getElementById('custom-help-button');
    if(ogHelpButton) {
      ogHelpButton.style.display = isOGWidgetActive ? 'flex' : 'none';
    }
  }

  changeFavicon(faviconUrl: string) {
    const link: HTMLLinkElement | null = document.querySelector("link[rel~='icon']");
    
    if (link) {
      link.href = faviconUrl;
    } else {
      const newLink = document.createElement('link');
      newLink.rel = 'icon';
      newLink.href = faviconUrl;
      document.head.appendChild(newLink);
    }
  }

  updateWidgetColors(color: string): void {
    let retries = 0;
    const maxRetries = 50;
    const checkInterval = 100;

    const checkWidgetLoaded = setInterval(() => {
      // Get the iframes
      const widgetFrame = document.getElementById('widget-frame') as HTMLIFrameElement;
      const launcherFrame = document.getElementById('launcher-frame') as HTMLIFrameElement;

      // Attempt to access the contentDocument of both iframes
      let widgetDocument: Document | null = null;
      let launcherDocument: Document | null = null;

      try {
        widgetDocument = widgetFrame?.contentDocument || widgetFrame?.contentWindow?.document || null;
        launcherDocument = launcherFrame?.contentDocument || launcherFrame?.contentWindow?.document || null;
      } catch (error) {
        console.error('Error accessing iframe content:', error);
      }

      // Check if we can access either document
      if ((widgetDocument || launcherDocument) || retries >= maxRetries) {
        clearInterval(checkWidgetLoaded);

        if (!widgetDocument && !launcherDocument) {
          console.warn('Cannot access either iframe content. Likely a cross-origin issue.');
          return;
        }

        // Apply styles to widgetDocument if accessible
        if (widgetDocument) {
          const headerWrapper = widgetDocument.querySelector('[data-testid="header-wrapper"]');
          if (headerWrapper) {
            const style = this.renderer.createElement('style');
            const css = `
              [data-testid="header-wrapper"] {
                background-color: ${color} !important;
              }
            `;
            this.renderer.appendChild(style, this.renderer.createText(css));
            widgetDocument.head.appendChild(style);
            console.log('Header styles applied to widget-frame.');
          } else {
            console.warn('Header wrapper not found in widget-frame.');
          }
        }

        // Apply styles to launcherDocument if accessible
        if (launcherDocument) {
          const launcherWrapper = launcherDocument.querySelector('[data-testid="launcher-wrapper"]');
          if (launcherWrapper) {
            const style = this.renderer.createElement('style');
            const css = `
              [data-testid="launcher-wrapper"] {
                background-color: ${color} !important;
              }
              [data-testid="launcher-wrapper"]:hover {
                background-color: ${color} !important;
              }
              [data-testid="launcher-wrapper"] svg.icon {
                fill: #FFFFFF !important;
              }
              [data-testid="launcher-wrapper"] .launcher-text {
                color: #FFFFFF !important;
              }
            `;
            this.renderer.appendChild(style, this.renderer.createText(css));
            launcherDocument.head.appendChild(style);
            console.log('Launcher styles applied to launcher-frame.');
          } else {
            console.warn('Launcher wrapper not found in launcher-frame.');
          }
        }
      }

      retries++;
    }, checkInterval);
  }

  getNavItemIcon(navIconName: string): string {
    return this[this.isIgnatiusThemeApplied ? 'titleToIconMap': 'titleToIconMapForOpenGov']?.[navIconName] || (this.isIgnatiusThemeApplied ? 'e-icons e-circle-add': 'fluent-AddCircle');
  }

  ngOnDestroy(){
    window.removeEventListener('load', this.onWindowLoad);
  }
  
}
